/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkPatchItemFieldSkipSchema = z.object({
  fieldId: z.int(),
  itemId: z.int(),
  reason: z.enum(['NOT_APPLICABLE_TO_ITEM_TYPE']),
});
